import React from "react";

import './FormInputCheckbox.scss' ;
import FormToggle from "root/ReactHookForm/ui/FormToggle";
import {SmartErrorDiv} from "./SmartErrorDiv";

export const labelPositions = {
    TOP: 1,
    RIGHT: 2,
}

const FormInputToggle = ( { control, readOnly, label, sectionName, name, style, className, labelPosition = labelPositions.TOP } ) =>
{
    const classText = className === undefined ? "form-field" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const labelTop = labelPosition === labelPositions.TOP ;

    const rightLabelStyle = { verticalAlign: 'super', paddingLeft: '30px', display: 'inline', position: 'relative', top: '-2px' } ;

    return (
        <div className={classText} style={styleObj}>
            { labelTop && <label className='col-form-label'>{label}</label> }
            <div style={{marginTop: '10px'}}>
                <FormToggle readOnly={readOnly} control={control} name={sectionName + '.' + name}/>
                { !labelTop && <div style={rightLabelStyle}><label className='col-form-label' style={{display: 'inline'}}>{label}</label></div> }
            </div>
        </div>
    )
}

export { FormInputToggle };